import React, { useEffect, useState } from "react";
import PageLayout from "../components/PageLayout";
import SearchHeader from "../components/SearchHeader";
import { useUser } from "../context/UserContext";
import { fetchNotices } from "../api/NoticeApi";
import { INotice } from "../exports/interfaces";
import { useParams } from "react-router-dom";
import { useLoader } from "../context/LoaderContext";
import { dynamicFailed } from "../hooks/useToast";
import EditNotice from "../components/notices/EditNotice";

const EditNoticesPage = () => {
  const { id } = useParams();
  const { setLoading } = useLoader();
  const [notice, setNotice] = useState<INotice>();
  const { user } = useUser();
  useEffect(() => {
    if (!user) {
      return;
    }
    Promise.all([fetchNotices()])
      .then(([noticeData]) => {
        const foundNotice = noticeData.find(
          (item: INotice) => item.id === Number(id),
        );
        setNotice(foundNotice);
        setTimeout(() => {
          setLoading(false);
        }, 1000);
      })
      .catch((error) => {
        dynamicFailed(`${error.message}`);
        setTimeout(() => {
          setLoading(false);
        }, 1000);
      });
  }, [id, setLoading, user]);
  return (
    <>
      <PageLayout>
        <SearchHeader />
        <div className="inner-main-content">
            <EditNotice notice={notice}/>
        </div>
      </PageLayout>
    </>
  );
};

export default EditNoticesPage;
